import capitalizeFirstLetter from './capitalizeFirstLetter'
import { isString } from './checks'

export const toCamelCase = (originalCase, string = '') => {
  if (!isString(string)) {
    return string
  }

  if (originalCase === '') {
    return string
  }

  if (!string?.includes(originalCase)) {
    return string
  }

  return string
    .split(originalCase)
    .map((text, index) => (index !== 0 ? capitalizeFirstLetter(text) : text))
    .join('')
}

export const kebabCaseToCamelCase = (string = '') => toCamelCase('-', string)

export const spacesToCamelCase = (string = '') => toCamelCase(' ', string)
